import { ThemeProvider } from "@mui/material";
import React from "react";
import { Popup } from "~/components/popup";
import { StyledSignUpSuccessMessage } from "./styles";
export const SignUpPopup = ({
  isShow,
  onClose
}) => /*#__PURE__*/React.createElement(Popup, {
  isShow: isShow,
  onClose: onClose,
  "data-qa": "sign-up-popup"
}, /*#__PURE__*/React.createElement(ThemeProvider, {
  theme: {
    signUpSuccess: {
      hasCheckEmail: true
    }
  }
}, /*#__PURE__*/React.createElement(StyledSignUpSuccessMessage, null)));
SignUpPopup.displayName = "SignUpPopup";